<style lang="scss" scoped>
.warn-pannel {
  width: 554px;
  height: 135px;
  background: rgba(255, 255, 255, 0.08);
  &::before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    width: 6px;
    height: 6px;
    border-top: 1px solid #f1382f;
    border-left: 1px solid #f1382f;
  }
  &::after {
    content: "";
    position: absolute;
    top: -1px;
    right: -1px;
    width: 6px;
    height: 6px;
    border-right: 1px solid #f1382f;
    border-top: 1px solid #f1382f;
  }
  .warn-panel {
    margin-left: 27px;
    width: 68px;
    height: 15px;
    background: linear-gradient(-45deg, transparent 6px, #f1382f 0);
    color: #ffffff;
    font-weight: 400;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    filter: drop-shadow(0px 0px 4px #f1382f);
  }
  .warn-content {
    width: 100%;
    margin-top: 12px;
    padding: 0 56px;
    .warn-item {
      width: 100%;
      height: 30px;
      color: #ffffff;
      display: flex;
      align-items: center;
      .panel {
        width: 54px;
        height: 20px;
        border-radius: 2px;
        font-weight: 350;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .error {
        background: rgba(241, 128, 47, 0.3);
        border: 1px solid rgba(241, 128, 47, 0.1);
        box-shadow: 0px 0px 4px 2px rgba(241, 128, 47, 0.2),
          inset 0px 0px 4px 2px rgba(241, 128, 47, 0.4);
      }
      .normal {
        background: rgba(45, 130, 255, 0.3);
        border: 1px solid rgba(45, 130, 255, 0.1);
        box-shadow: 0px 0px 4px 2px rgba(45, 130, 255, 0.2),
          inset 0px 0px 4px 2px rgba(45, 130, 255, 0.4);
      }
      .message {
        margin-left: 18px;
        width: 302px;
        height: 24px;
        font-weight: 350;
        font-size: 16px;
        line-height: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .icon {
        width: 20px;
        height: 10px;
        margin-left: 12px;
        background-image: url("../../../assets/pagesImg/jiantou.png");
        background-size: cover;
        cursor: pointer;
      }
    }
  }
  .line::before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 6px;
    height: 6px;
    border-bottom: 1px solid #f1382f;
    border-left: 1px solid #f1382f;
  }

  .line::after {
    content: "";
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 6px;
    height: 6px;
    border-bottom: 1px solid #f1382f;
    border-right: 1px solid #f1382f;
  }
}
</style>

<template>
  <div class="warn-pannel">
    <div class="warn-panel">WARNING</div>
    <div class="warn-content">
      <div
        class="warn-item"
        v-for="(item, index) in showList"
        :key="`warn${index}`"
      >
        <div class="panel" :class="item.status == 0 ? 'error' : 'normal'">
          {{ item.status == 0 ? "未处理" : "已处理" }}
        </div>
        <div class="message">{{ item.content }}</div>
        <div class="icon"></div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  props: {
    warnPannelData: Array,
  },
  computed: {
    showList() {
      if (this.warnPannelData?.length !== 0) {
        return this.warnPannelData;
      }
      return [];
    },
  },
};
</script>
